
function makeParams(paramName, value, isSelected) {
    const params = {
        remove: isSelected,
    };
    params[paramName] = value;
    return params;
}
export default makeParams;
